import React from 'react';
import { func, oneOf } from 'prop-types';
import { translate } from 'react-i18next';
import { useSelector } from 'react-redux';

import { getLocaleCode } from '@dragonfruit/redux/locale';

import styles from './Disclaimer.scss';

function Disclaimer({ type, t }) {
  const currentLocale = useSelector(getLocaleCode);

  return (
    <p
      className={styles.root}
      dangerouslySetInnerHTML={{
        __html: t(`onboarding.termsPrivacy.${type}`, {
          termsLink: t('footer:footer.termsLink', {
            locale: currentLocale,
          }),
          privacyLink: t('footer:footer.privacyLink', {
            locale: currentLocale,
          }),
        }),
      }}
    />
  );
}

Disclaimer.propTypes = {
  t: func.isRequired,
  type: oneOf(['login', 'signup']).isRequired,
};

export default translate(['onboarding', 'footer'])(Disclaimer);



// WEBPACK FOOTER //
// ./app/components/Disclaimer/Disclaimer.jsx